/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log("Hello World! (from sd-viblock-sd-mobile-image-slider block)");
/* eslint-enable no-console */
document.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll('.mobile-slider-block');

	sliders.forEach(slider => {
		const wrapper = slider.querySelector('.mobile-slider-wrapper');
		const items = Array.from(wrapper.children);
		const prevBtn = slider.querySelector('.slideshow-prev');
		const nextBtn = slider.querySelector('.slideshow-next');

		let currentIndex = 0;
		let isMobile = window.innerWidth < 768;

		// Add captions for image alt text
		const addImageCaptions = () => {
			const images = wrapper.querySelectorAll('img');

			images.forEach(img => {
				const altText = img.getAttribute('alt');
				if (!altText) return;

				// Check if caption already exists
				const imageContainer = img.closest('figure') || img.closest('.wp-block-image') || img.closest('.stk-block-image');
				const existingCaption = imageContainer?.nextElementSibling?.classList.contains('mobile-slider-caption');
				if (existingCaption) return;

				// Create caption element
				const caption = document.createElement('div');
				caption.className = 'mobile-slider-caption';
				caption.textContent = altText;

				// Insert caption after the image's parent container
				if (imageContainer) {
					imageContainer.insertAdjacentElement('afterend', caption);
				} else {
					img.insertAdjacentElement('afterend', caption);
				}
			});
		};

		const updateSlider = () => {
			if (!isMobile) return;

			items.forEach((item, index) => {
				item.style.transform = `translateX(-${currentIndex * 100}%)`;
			});

			prevBtn.disabled = currentIndex === 0;
			nextBtn.disabled = currentIndex === items.length - 1;
		};

		const checkMobile = () => {
			const wasMobile = isMobile;
			isMobile = window.innerWidth < 768;

			if (isMobile !== wasMobile) {
				if (!isMobile) {
					items.forEach(item => {
						item.style.transform = '';
					});
				} else {
					updateSlider();
				}
			}
		};

		prevBtn.addEventListener('click', () => {
			if (currentIndex > 0) {
				currentIndex--;
				updateSlider();
			}
		});

		nextBtn.addEventListener('click', () => {
			if (currentIndex < items.length - 1) {
				currentIndex++;
				updateSlider();
			}
		});

		// Initialize captions
		addImageCaptions();

		window.addEventListener('resize', checkMobile);
		checkMobile();
		updateSlider();
	});
});
// document.addEventListener('DOMContentLoaded', () => {
// 	const sliders = document.querySelectorAll('.mobile-slider-block');
//
// 	sliders.forEach(slider => {
// 		const wrapper = slider.querySelector('.mobile-slider-wrapper');
// 		const items = Array.from(wrapper.children);
// 		const prevBtn = slider.querySelector('.slideshow-prev');
// 		const nextBtn = slider.querySelector('.slideshow-next');
//
// 		let currentIndex = 0;
// 		let isMobile = window.innerWidth < 768;
//
// 		const updateSlider = () => {
// 			if (!isMobile) return;
//
// 			items.forEach((item, index) => {
// 				item.style.transform = `translateX(-${currentIndex * 100}%)`;
// 			});
//
// 			prevBtn.disabled = currentIndex === 0;
// 			nextBtn.disabled = currentIndex === items.length - 1;
// 		};
//
// 		const checkMobile = () => {
// 			const wasMobile = isMobile;
// 			isMobile = window.innerWidth < 768;
//
// 			if (isMobile !== wasMobile) {
// 				if (!isMobile) {
// 					items.forEach(item => {
// 						item.style.transform = '';
// 					});
// 				} else {
// 					updateSlider();
// 				}
// 			}
// 		};
//
// 		prevBtn.addEventListener('click', () => {
// 			if (currentIndex > 0) {
// 				currentIndex--;
// 				updateSlider();
// 			}
// 		});
//
// 		nextBtn.addEventListener('click', () => {
// 			if (currentIndex < items.length - 1) {
// 				currentIndex++;
// 				updateSlider();
// 			}
// 		});
//
// 		window.addEventListener('resize', checkMobile);
// 		checkMobile();
// 		updateSlider();
// 	});
// });
